import { render, staticRenderFns } from "./order-view.vue?vue&type=template&id=c1d9e666&scoped=true&"
import script from "./order-view.vue?vue&type=script&lang=js&"
export * from "./order-view.vue?vue&type=script&lang=js&"
import style0 from "./order-view.vue?vue&type=style&index=0&id=c1d9e666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d9e666",
  null
  
)

export default component.exports